import { useNavigate } from 'react-router-dom'

import { useClearPrepareAirdropData } from 'state/airdrop/hooks'

import { Links } from 'constants/link'

import { Button, Icon } from 'components/ui'

import { Wrap, IconWrap, Title, Text } from './Style'

const NotFound = () => {
  const navigate = useNavigate()

  const clearPrepareAirdropData = useClearPrepareAirdropData()

  const handleGoHome = () => {
    navigate(Links.HOME)
    clearPrepareAirdropData()
  }

  return (
    <Wrap>
      <IconWrap>
        <Icon name='notFound' size='fill' />
      </IconWrap>

      <Title>Something&rsquo;s missing</Title>
      <Text>We&nbsp;can&rsquo;t seem to&nbsp;find the page you&rsquo;re looking for.</Text>

      <Button size='large' fullSize onClick={handleGoHome}>
        _home-page
      </Button>
    </Wrap>
  )
}

export { NotFound }
